import * as classNames from 'classnames'
import keys from 'lodash-es/keys'
import * as React from 'react'

import { Site } from '../../../../common/constants/siteList'
import quickLinksConfig from '../../../../config/layout/quickLinks'
import TextLink from '../textLink'
import SiteLinks from './siteLinks'

import * as styles from './quickLinksFooter.module.css'

interface IProps {
  currentSite: Site
}
interface IState {
  collapsed: boolean
}

class QuickLinksFooter extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = { collapsed: false }
  }

  public componentDidMount() {
    this.setState({ collapsed: true })
  }

  public render() {
    const { currentSite } = this.props
    const { collapsed } = this.state
    const sites = keys(quickLinksConfig)
    const toggleClassNames = classNames(styles.toggleIcon, {
      [styles.toggleIconPlus]: collapsed
    })
    const contentClassNames = classNames(styles.content, {
      [styles.contentHidden]: collapsed
    })

    return (
      <div className={styles.quicklinks} role="navigation">
        <div className={styles.gridWide}>
          <div className={styles.container}>
            <div className={styles.title}>
              <div
                className={styles.toggle}
                onClick={this.toggleContent}
                role="button"
              >
                <i className={toggleClassNames} />
                <TextLink className={styles.toggleText}>Quick Links</TextLink>
                <span className={styles.toggleSubText}>
                  Explore popular categories
                </span>
              </div>
            </div>
            <div className={contentClassNames}>
              {sites.map((site, index) => (
                <SiteLinks currentSite={currentSite} site={site} key={index} />
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }

  private toggleContent = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault()
    this.setState({ collapsed: !this.state.collapsed })
  }
}

export default QuickLinksFooter
